import { render } from "./Author.vue?vue&type=template&id=4ba816fe&scoped=true&ts=true"
import script from "./Author.vue?vue&type=script&lang=ts"
export * from "./Author.vue?vue&type=script&lang=ts"

import "./Author.vue?vue&type=style&index=0&id=4ba816fe&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba816fe"]])

export default __exports__